import api from './api';

export interface WellnessConfig {
  id: number;
  name: string;
  from_date: string | null;
  to_date: string | null;
  priority: number;
  active: boolean;
  from_mobile_version: string | null;
  data: any | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface WellnessConfigCreate {
  name: string;
  from_date?: string | null;
  to_date?: string | null;
  priority?: number;
  active?: boolean;
  from_mobile_version?: string | null;
  data?: any | null;
}

export interface WellnessConfigUpdate {
  name?: string;
  from_date?: string | null;
  to_date?: string | null;
  priority?: number;
  active?: boolean;
  from_mobile_version?: string | null;
  data?: any | null;
}

export const wellnessConfigService = {
  async getAll(tenantId?: number): Promise<WellnessConfig[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/wellness-configs/${params}`);
    return response.data;
  },
  async getById(id: number): Promise<WellnessConfig> {
    const response = await api.get(`/wellness-configs/${id}`);
    return response.data;
  },
  async create(tenantId: number, data: WellnessConfigCreate): Promise<WellnessConfig> {
    const response = await api.post(`/wellness-configs/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  async update(id: number, data: WellnessConfigUpdate): Promise<WellnessConfig> {
    const response = await api.put(`/wellness-configs/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`/wellness-configs/${id}`);
  },
};
